import './styles/job-log-item.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import classnames from 'classnames'
import moment     from 'moment'

export default class JobLogItem extends React.Component {
  static propTypes = {
    component:     PropTypes.string,
    businessLog:   PropTypes.array.isRequired,
    showDebugLogs: PropTypes.bool.isRequired,
  }

  render() {
    const { component, businessLog, showDebugLogs } = this.props

    const logs         = businessLog || []
    const reversedLogs = []    

    for (const log of logs) reversedLogs.push(log)

    return (
      <div className="job-log-item">
        {
          reversedLogs.filter((log) => showDebugLogs || log.type !== 'DEBUG').map((log, index) => {
            const timestamp = moment(log.timestamp).format('YYYY-MM-DD h:mm:ss')
            const className = classnames('job-log-row', { error: log.type === 'ERROR', debug: log.type === 'DEBUG' })

            return (
              <div key={index} className={className}>
                { component && <div className="component">{ component }</div> }
                <div className="message">{ log.message }</div>
                <div className="time-stamp">{ timestamp }</div>
              </div>
            )
          })
        }
      </div>
    )
  }
}